module.exports = __webpack_public_path__ + "img/contact-whatsapp.02ab9b9e.svg";